import React, { useState } from "react";
import { Badge, Box, Fab, Paper, Typography, Zoom } from "@mui/material";
import { SmartToy as RobotIcon, Lock as LockIcon } from "@mui/icons-material";

const AssistenteBloqueado = () => {
	const [avisoAberto, setAvisoAberto] = useState(false);

	return (
		<Box sx={{ position: "fixed", bottom: 60, right: 20, zIndex: 9999 }}>
			<Zoom in={avisoAberto}>
				<Paper
					elevation={6}
					sx={{
						position: "absolute",
						bottom: 70,
						right: 0,
						width: { xs: "80vw", sm: 300 },
						p: 2,
						borderRadius: 3,
						display: "flex",
						gap: 1.5,
					}}
				>
					<LockIcon sx={{ color: "#6b7280", mt: 0.25 }} />
					<Box>
						<Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
							Assistente IA indisponível para o seu usuário
						</Typography>
						<Typography variant="body2" sx={{ color: "text.secondary", mt: 0.5 }}>
							Sua empresa tem o Assistente IA, mas o seu usuário não tem permissão para usá-lo. Peça ao
							administrador para liberar o acesso ao Financeiro.
						</Typography>
					</Box>
				</Paper>
			</Zoom>

			<Fab
				aria-label="Assistente IA sem permissão"
				onClick={() => setAvisoAberto(!avisoAberto)}
				sx={{
					width: 56,
					height: 56,
					color: "white",
					background: "linear-gradient(135deg, #9ca3af 0%, #6b7280 100%)",
					boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
					"&:hover": { background: "linear-gradient(135deg, #6b7280 0%, #9ca3af 100%)" },
				}}
			>
				<Badge
					overlap="circular"
					anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
					badgeContent={<LockIcon sx={{ fontSize: 14, color: "#6b7280", bgcolor: "white", borderRadius: "50%", p: "1px" }} />}
				>
					<RobotIcon />
				</Badge>
			</Fab>
		</Box>
	);
};

export default AssistenteBloqueado;
